<template>
  <Box>
    <v-layout
      :style="{ 'min-height': `${minHeight}px` }"
      fill-height
      align-center
      justify-center
    >
      <span class="text--small text--center">
        {{ $t('Common.boxGenericError') }}<br>
        <a :title="$t('Common.tryAgain')" @click.prevent="loadData">
          {{ $t('Common.tryAgain') }}
        </a>
      </span>
    </v-layout>
  </Box>
</template>

<script>
export default {
  name: 'ErrorState',
  props: {
    minHeight: {
      type: Number,
      default: 384
    }
  },
  methods: {
    loadData () {
      this.$emit('loadData')
    }
  }
}
</script>
